export default {
  slug: "client",
  code: "CLT",
  label: "Client",
  logoFamily: "jb",
};
